import * as React from "react";
import { useSelector } from "react-redux";

import { Modal as GenericModal } from "@ui/Molecules";

import slugify from "@services/SlugifyFacade";

import { useTranslate } from "@hooks/useTranslate";

import {
  getModalInfo,
  getModalOptions,
  getModalAutohideOption,
  getModals,
} from "@app/redux/modals/modals.selectors";
import { IStore } from "@app/redux/reducers";
import { useModalStore } from "@app/hooks/useModalStore";

export type Size = "thin" | "base" | "base_x2" | "large";
export type Padding = "normal" | "base_x9" | "none";

interface Props {
  auto?: boolean;
  cancel?: (e?: any) => void;
  cancelText?: string;
  centeredContent?: boolean;
  children?: React.ReactNode;
  className?: string;
  close?: (e?: any) => void;
  closeButtonId?: string;

  id?: string;
  isSubmitBtnDisabled?: boolean;
  padding?: Padding;
  size?: Size;
  submit?: (e?: any) => void;
  submitText?: string;
  testId?: string;
  title: string;
  withContainedHeight?: boolean;
  withCloseBtn?: boolean;
  withFooter?: boolean;
  withHeader?: boolean;
  withCancelBtn?: boolean;
  withMobileHeaderGutter?: boolean;
  submitBtnColor?: "green" | "blue" | "red";
  customHeader?: React.ReactNode;
  isMobileFullScreen?: boolean;
  isBottomVariant?: boolean;
  bodyId?: string;
  isSubmitBtnLoading?: boolean;
  onHideModal?: (id: string) => void;
}

const Modal = (props: Props): React.ReactElement => {
  const translate = useTranslate("batmaid_pwa_generic");
  const { hideModal, showModal } = useModalStore();

  const getInfo = (id: string) =>
    useSelector((state: IStore) => getModalInfo(state, id));
  const getOptions = (id: string) =>
    useSelector((state: IStore) => getModalOptions(state, id));
  const getAutohide = (id: string) =>
    useSelector((state: IStore) => getModalAutohideOption(state, id));
  const modals = useSelector(getModals);

  const handleHideModal = (id: string) => {
    hideModal(id);
    props.onHideModal?.(id);
  };

  return (
    <GenericModal
      {...props}
      id={props.id || slugify(props.title)}
      submitText={props.submitText || translate("button_confirm")}
      cancelText={props.cancelText || translate("button_cancel")}
      showModal={showModal}
      hideModal={handleHideModal}
      getInfo={getInfo}
      getOptions={getOptions}
      getAutohide={getAutohide}
      modals={modals}
    />
  );
};

export { Modal };
